// Minimal CZ/SK/EN/HU i18n
import { createContext, useContext, useEffect, useState } from "react";
import { loadRates } from "./currency";

const dict = {
  cs: {
    lang_name: "Čeština",
    nav_home: "Domů", nav_products: "Produkty", nav_bundles: "Balíčky", nav_blog: "Blog", nav_contact: "Kontakt", nav_account: "Účet", nav_admin: "Admin",
    nav_login: "Přihlásit", nav_logout: "Odhlásit", nav_register: "Registrace",
    hero_title: "Digital Software Made Simple and Secure",
    hero_sub: "Okamžité doručení e-mailem • Ověřené licence • Česká/Slovenská podpora",
    hero_cta1: "Procházet produkty", hero_cta2: "Nejprodávanější",
    bestsellers: "Nejprodávanější", microsoft: "Microsoft Produkty", adobe: "Adobe Software",
    protection: "Ochrana a optimalizace PC", bundles: "Výhodné balíčky", reviews: "Hodnocení zákazníků",
    faq: "Často kladené dotazy", trust: "Důvěra a bezpečnost", why_us: "Proč nás vybrat",
    add_to_cart: "Přidat do košíku", buy_now: "Koupit teď",
    instant_delivery: "Okamžité doručení", lifetime: "Trvalá licence", online_activation: "Online aktivace",
    bestseller: "Nejprodávanější", sale: "Akce", new: "Novinka",
    cart_empty: "Košík je prázdný", cart_title: "Váš košík", subtotal: "Mezisoucet", total: "Celkem",
    checkout: "K pokladně", continue_shop: "Pokračovat v nákupu",
    your_keys: "Vaše licenční klíče", copy: "Kopírovat", copied: "Zkopírováno!",
    in_stock: "Skladem", out_of_stock: "Vyprodáno",
  },
  sk: {
    lang_name: "Slovenčina",
    nav_home: "Domov", nav_products: "Produkty", nav_bundles: "Balíky", nav_blog: "Blog", nav_contact: "Kontakt", nav_account: "Účet", nav_admin: "Admin",
    nav_login: "Prihlásiť", nav_logout: "Odhlásiť", nav_register: "Registrácia",
    hero_title: "Digital Software Made Simple and Secure",
    hero_sub: "Okamžité doručenie e-mailom • Overené licencie • Česká/Slovenská podpora",
    hero_cta1: "Prehliadať produkty", hero_cta2: "Najpredávanejšie",
    bestsellers: "Najpredávanejšie", microsoft: "Microsoft Produkty", adobe: "Adobe Softvér",
    protection: "Ochrana a optimalizácia PC", bundles: "Výhodné balíky", reviews: "Hodnotenia zákazníkov",
    faq: "Často kladené otázky", trust: "Dôvera a bezpečnosť", why_us: "Prečo nás vybrať",
    add_to_cart: "Pridať do košíka", buy_now: "Kúpiť teraz",
    instant_delivery: "Okamžité doručenie", lifetime: "Trvalá licencia", online_activation: "Online aktivácia",
    bestseller: "Najpredávanejšie", sale: "Akcia", new: "Novinka",
    cart_empty: "Košík je prázdny", cart_title: "Váš košík", subtotal: "Medzisúčet", total: "Spolu",
    checkout: "K pokladni", continue_shop: "Pokračovať v nákupe",
    your_keys: "Vaše licenčné kľúče", copy: "Kopírovať", copied: "Skopírované!",
    in_stock: "Skladom", out_of_stock: "Vypredané",
  },
  en: {
    lang_name: "English",
    nav_home: "Home", nav_products: "Products", nav_bundles: "Bundles", nav_blog: "Blog", nav_contact: "Contact", nav_account: "Account", nav_admin: "Admin",
    nav_login: "Sign in", nav_logout: "Sign out", nav_register: "Sign up",
    hero_title: "Digital Software Made Simple and Secure",
    hero_sub: "Instant email delivery • Verified licenses • Czech/Slovak support",
    hero_cta1: "Browse products", hero_cta2: "Best sellers",
    bestsellers: "Best sellers", microsoft: "Microsoft Products", adobe: "Adobe Software",
    protection: "PC protection & optimization", bundles: "Value bundles", reviews: "Customer reviews",
    faq: "Frequently asked questions", trust: "Trust & security", why_us: "Why choose us",
    add_to_cart: "Add to cart", buy_now: "Buy now",
    instant_delivery: "Instant delivery", lifetime: "Lifetime license", online_activation: "Online activation",
    bestseller: "Best seller", sale: "Sale", new: "New",
    cart_empty: "Your cart is empty", cart_title: "Your cart", subtotal: "Subtotal", total: "Total",
    checkout: "Checkout", continue_shop: "Continue shopping",
    your_keys: "Your license keys", copy: "Copy", copied: "Copied!",
    in_stock: "In stock", out_of_stock: "Out of stock",
  },
  hu: {
    lang_name: "Magyar",
    nav_home: "Főoldal", nav_products: "Termékek", nav_bundles: "Csomagok", nav_blog: "Blog", nav_contact: "Kapcsolat", nav_account: "Fiók", nav_admin: "Admin",
    nav_login: "Bejelentkezés", nav_logout: "Kijelentkezés", nav_register: "Regisztráció",
    hero_title: "Digital Software Made Simple and Secure",
    hero_sub: "Azonnali e-mailes kézbesítés • Hitelesített licencek • Cseh/szlovák ügyfélszolgálat",
    hero_cta1: "Termékek böngészése", hero_cta2: "Legnépszerűbb",
    bestsellers: "Legnépszerűbb", microsoft: "Microsoft termékek", adobe: "Adobe szoftverek",
    protection: "PC védelem és optimalizálás", bundles: "Kedvező csomagok", reviews: "Vásárlói vélemények",
    faq: "Gyakori kérdések", trust: "Bizalom és biztonság", why_us: "Miért minket válassz",
    add_to_cart: "Kosárba", buy_now: "Megveszem",
    instant_delivery: "Azonnali kézbesítés", lifetime: "Élethosszig tartó licenc", online_activation: "Online aktiválás",
    bestseller: "Bestseller", sale: "Akció", new: "Új",
    cart_empty: "A kosár üres", cart_title: "Kosarad", subtotal: "Részösszeg", total: "Összesen",
    checkout: "Pénztár", continue_shop: "Tovább vásárolok",
    your_keys: "Licenckulcsaid", copy: "Másolás", copied: "Másolva!",
    in_stock: "Raktáron", out_of_stock: "Elfogyott",
  },
};

export const LANGS = [
  { code: "cs", flag: "🇨🇿", name: "Čeština" },
  { code: "sk", flag: "🇸🇰", name: "Slovenčina" },
  { code: "en", flag: "🇬🇧", name: "English" },
  { code: "hu", flag: "🇭🇺", name: "Magyar" },
];

const I18nCtx = createContext(null);
export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem("ss_lang");
    if (stored && dict[stored]) return stored;
    // Auto-detect from browser
    const browserLang = (navigator.language || "cs").slice(0, 2).toLowerCase();
    return dict[browserLang] ? browserLang : "cs";
  });
  useEffect(() => {
    localStorage.setItem("ss_lang", lang);
    document.documentElement.lang = lang;
    // Refresh ČNB rates so price formatting picks the right currency
    loadRates();
    // Bust caches that include language-specific responses so the UI reloads in the new language
    try { window.dispatchEvent(new CustomEvent("ss-lang-changed", { detail: lang })); } catch (e) { /* ignore */ }
  }, [lang]);
  const t = (key) => dict[lang]?.[key] || dict.cs[key] || key;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}
export const useI18n = () => useContext(I18nCtx);
